import _ from 'lodash';
import { isPlaylist, isHls } from './audioFormats';
import { formatUrl } from './proxy';

export const normalizedStreams = (streams) => {
  if (_.isEmpty(streams)) return streams;
  return _(streams)
    .map(stream => ({ src: stream.url || stream.src }))
    .reject(stream => !stream.src || isPlaylist(stream.src))
    // natively supported audio formats go first
    .sort((a, b) => {
      const [x, y] = [a.src, b.src].map(s => isHls(s));
      if (x || y) return x > y ? 1 : -1;
      return 0;
    })
    .value();
};

export const proxyStreams = (streams, insecureOnly = true) => {
  const isSecureOrigin = window.location.href.startsWith('https://');
  const format = url => ((!insecureOnly || url.startsWith('http://'))
    ? formatUrl(url)
    : url);
  if ((!isSecureOrigin && insecureOnly) || !streams.length) return streams;
  return streams.map(s => ({ ...s, src: format(s.src) }));
};

export default {
  normalizedStreams,
};
